import dateFormat from 'dateformat'
import { host } from '../../config'

export default function utils() {
  return {
    data() {
      return {
        isLogin: false,
      }
    },
    methods: {
      async getLogin() {
        return  this.$http.get(host + '/api/customer/is_login', {withCredentials: true}).then(res => {
          this.isLogin = res.data.data
          return this.isLogin
        })
        .catch(e => {
          // if (e.response.data.message == '无登录信息') {
          //   this.$router.push('/login')
          // } else {
          // }
        })
      }
    },
    destroyed() {
      
    },
    
    filters:{
      filterTime(val) {
        return dateFormat(new Date(val),"yyyy-mm-dd HH:MM:ss") ;
      },
      safeNum(num) {
        return Math.round(num*100)/100
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/utils.js